import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PageHeader from '../../../../shared/components/PageHeader';
import Page from '../../../../shared/components/Page';
import LearningAssetTableV2 from './LearningAssetTableV2';
import {
    getLearningAsset,
    getWelcomeAsset,
    getLearningAssetStatus,
    updateLearningAssetArchiveStatus,
    getManageLearningAssetsTableData,
    postAlgoliaSearch,
    updateAlgoliaSearchFilters,
    updateAlgoliaSearchIndices,
    updateAlgoliaSearchQuery,
    initializeAlgoliaSearchState,
    clearAlgoliaSearchResult,
    getSearchKey,
} from '../../../../shared/actions';
import { RuntimeContext } from '../../../../../common/RuntimeContext';

export class ManageLearningAssets extends Component {
    static propTypes = {
        getLearningAsset: PropTypes.func.isRequired,
        getWelcomeAsset: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        match: PropTypes.shape({
            params: PropTypes.shape({
                section: PropTypes.string
            })
        }),
        updateLearningAssetArchiveStatus: PropTypes.func.isRequired,
        isContentAuthor: PropTypes.bool.isRequired,
        isVerbAdmin: PropTypes.bool.isRequired,
        isContentAdmin: PropTypes.bool.isRequired,
        loggedInUser: PropTypes.object,
        sortLearningAssets: PropTypes.func,
        getLearningAssetStatus: PropTypes.func,
        clearAlgoliaSearchResult: PropTypes.func,
        postAlgoliaSearch: PropTypes.func,
        updateAlgoliaSearchFilters: PropTypes.func,
        updateAlgoliaSearchQuery: PropTypes.func,
        initializeAlgoliaSearchState: PropTypes.func,
        algoliaSearch: PropTypes.object
    };

    constructor(props) {
        super(props);
        this.state = {
          searchKey:  '',
        };
        this.intervalID = ''
    }

    static contextType = RuntimeContext;
    
    componentDidMount() {
      this.getActivityKey();
      this.intervalID = setInterval(this.getActivityKey, 3600000);
    }

    getActivityKey = () => getSearchKey({id: 'F6ikCMV6kvhMfivWEUxB'}, this.context.pathsWeb).then(searchKey => this.setState({searchKey}));

    componentWillUnmount() {
        clearInterval(this.intervalID);
    }

    postAlgoliaSearch = (searchQuery, indexName, filters) => {
        const { postAlgoliaSearch, algoliaSearch } = this.props;
        const { searchKey } = this.state;
        const filtersToPass = filters || JSON.parse(JSON.stringify(algoliaSearch.filters));

        // If both search query and filters are empty, clear the search results
        const hasQuery = searchQuery && searchQuery.trim() !== '';
        const hasFilters = filtersToPass && Object.keys(filtersToPass).length > 0;
        
        if (!hasQuery && !hasFilters) {
            this.props.updateAlgoliaSearchQuery({
                pageName: 'ManageLearningAssets',
                query: ''
            });
            this.clearAlgoliaSearchResult();
            return Promise.resolve([]);
        }

        this.props.updateAlgoliaSearchQuery({
            pageName: 'ManageLearningAssets',
            query: searchQuery || ''
        });

        return postAlgoliaSearch({
            pageName: 'ManageLearningAssets',
            searchKey,
            query: searchQuery || '',
            indexName,
            filters: filtersToPass,
            customSearchParams: {
                hitsPerPage: 1000
            },
            pathsContext: this.context.pathsWeb
        });
    };

    clearAlgoliaSearchResult = () => {
        this.props.clearAlgoliaSearchResult({ pageName: 'ManageLearningAssets' });
    };

    updateAlgoliaSearchFilters = (newFilters) => {
        this.props.updateAlgoliaSearchFilters({
            pageName: 'ManageLearningAssets',
            filters: newFilters
        });
    };

    updateAlgoliaSearchQuery = (newQuery) => {
        this.props.updateAlgoliaSearchQuery({
            pageName: 'ManageLearningAssets',
            query: newQuery
        });
    };

    render() {
        const {
            isContentAdmin,
            isVerbAdmin,
            sortLearningAssets,
            isContentAuthor,
            history,
            getLearningAsset,
            getWelcomeAsset,
            loggedInUser,
            getLearningAssetStatus,
            updateLearningAssetArchiveStatus,
            initializeAlgoliaSearchState,
            algoliaSearch
        } = this.props;

        return (
            <Page className={'manage-learning-assets'}>
                <PageHeader
                    title={'Activities'}
                    className={'adminPageHeader'}
                    hideBackButton={true}
                />
                <div className={'manageTrackV2Wrapper adminWrapper col-10 col-offset-1'}>
                    <LearningAssetTableV2
                        isWelcomeAssetTable={false}
                        isContentAdmin={isContentAdmin}
                        isContentAuthor={isContentAuthor}
                        isVerbAdmin={isVerbAdmin}
                        history={history}
                        loggedInUser={loggedInUser}
                        updateLearningAssetArchiveStatus={updateLearningAssetArchiveStatus}
                        getLearningAssetStatus={getLearningAssetStatus}
                        getManageLearningAssetsTableData={getManageLearningAssetsTableData}
                        sortLearningAssets={sortLearningAssets}
                        getLearningAsset={getLearningAsset}
                        getWelcomeAsset={getWelcomeAsset}
                        selectColumnToSort={this.selectColumnToSort}
                        postAlgoliaSearch={this.postAlgoliaSearch}
                        updateAlgoliaSearchFilters={this.updateAlgoliaSearchFilters}
                        updateAlgoliaSearchQuery={this.updateAlgoliaSearchQuery}
                        clearAlgoliaSearchResult={this.clearAlgoliaSearchResult}
                        initializeAlgoliaSearchState={initializeAlgoliaSearchState}
                        algoliaSearch={algoliaSearch}
                        hideCreatedByAndAuthorColumns={true}
                    />
                </div>
            </Page>
        );
    }
}

export const mapStateToProps = (state) => {
    const {
        algoliaSearch,
        admin: { sort },
        auth: { isContentAuthor, isVerbAdmin, isContentAdmin, loggedInUser, loggedInUserId }
    } = state;

    return {
        loggedInUser,
        loggedInUserId,
        isContentAuthor,
        isVerbAdmin,
        isContentAdmin,
        sort: sort.learningAssets,
        algoliaSearch: algoliaSearch.ManageLearningAssets
    };
};

const mapDispatchToProps = (dispatch) => ({
    postAlgoliaSearch: (params) => dispatch(postAlgoliaSearch(params)),
    updateAlgoliaSearchFilters: (params) => dispatch(updateAlgoliaSearchFilters(params)),
    updateAlgoliaSearchIndices: (params) => dispatch(updateAlgoliaSearchIndices(params)),
    updateAlgoliaSearchQuery: (params) => dispatch(updateAlgoliaSearchQuery(params)),
    clearAlgoliaSearchResult: (params) => dispatch(clearAlgoliaSearchResult(params)),
    initializeAlgoliaSearchState: (params) => dispatch(initializeAlgoliaSearchState(params)),
    getLearningAsset: (params) => dispatch(getLearningAsset(params)),
    getWelcomeAsset: (params) => dispatch(getWelcomeAsset(params)),
    getLearningAssetStatus: (learningAssetId, query) => getLearningAssetStatus(learningAssetId, query),
    getManageLearningAssetsTableData: (params) => getManageLearningAssetsTableData(params),
    updateLearningAssetArchiveStatus: (params) => dispatch(updateLearningAssetArchiveStatus(params))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageLearningAssets));
